var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Botswana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2196f3",
    d: "M43.344,29H4.656C6.879,37.621,14.684,44,24,44S41.121,37.621,43.344,29z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2196f3",
    d: "M24,4C14.684,4,6.879,10.379,4.656,19h38.689C41.121,10.379,33.316,4,24,4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M43.344,19H4.656c-0.169,0.655-0.304,1.321-0.407,2h39.502C43.649,20.321,43.513,19.655,43.344,19z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M43.751,27H4.249c0.102,0.679,0.238,1.345,0.407,2h38.689C43.513,28.345,43.649,27.679,43.751,27z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M44,24c0-1.022-0.101-2.019-0.249-3H4.249C4.101,21.981,4,22.978,4,24s0.101,2.019,0.249,3h39.502 C43.899,26.019,44,25.022,44,24z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Botswana);
export default __webpack_public_path__ + "static/media/icons8-botswana.4fd715fe66fe3d020d58329107153f7b.svg";
export { ForwardRef as ReactComponent };